import { Fragment } from "react";

interface IProps {
  value?: string | number[];
}

const PrioritySequence = ({ value }: IProps) => {
  const priorities = Array.isArray(value)
    ? value
    : value && value !== "-"
      ? value.split("-")
      : [];

  if (!priorities.length) return <>-</>;

  return (
    <span dir="rtl" className="inline-flex flex-row items-center justify-center whitespace-nowrap">
      {priorities.map((priority, index) => (
        <Fragment key={index}>
          <span>{priority}</span>
          {index < priorities.length - 1 ? <span aria-hidden="true">-</span> : null}
        </Fragment>
      ))}
    </span>
  );
};

export default PrioritySequence;
